import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApi from "../utils/useApi";

export default function useZones({ active_only = false }) {
  const { getZones } = useApi();
  const { user } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: [
      "zones",
      user?.user_id ?? null,
      user?.active_branch_id ?? null,
      active_only,
    ],
    queryFn: () => getZones(active_only),
    select: (data) => {
      const zones = data?.data;

      const formatedZones = [...(zones || [])]
        .map((zone) => ({
          label: zone.description,
          value: zone.id,
        }))
        .sort((a, b) =>
          String(a.label || "").localeCompare(String(b.label || ""), "pt-BR", {
            sensitivity: "base",
          })
        );

      const zonesWithAll = [
        { label: "Todos", value: "all" },
        ...(formatedZones || []),
      ];

      return {
        zones: zonesWithAll,
        count: zones?.length || [],
      };
    },
  });

  return { data: data?.zones, count: data?.count, isLoading };
}
